
export class DataModel 
{
  
  descriptor;
  
  constructor(descriptor) {
    this.descriptor = descriptor;

  }
  
  form(base) 
  {
    return this._mapMezoConfig({target: base, section: 'input', filter: true});
  }
  
  list(base) {
    return this._mapMezoConfig({target: base, section: 'list', filter: false});
  }  
  
  view(base) {
    return this._mapMezoConfig({target: base, section: 'view', filter: false});
  }
  
  create() 
  {
    return this.form().mezok.reduce((r, mezo) => {
      r[mezo.id] = null;
      return r
    }, {})
  }
  
  state(form, errors = null) {
    
    errors = errors || {}
    
    form.mezok.forEach(mezo => {
      mezo.state = errorState(errors[mezo.id])
    })

    function errorState(message) {
      return message ? {state: "error", message} : null;
    }
  }
  
  _mapMezoConfig({target, section, filter}) 
  {
    target = target || {};
    
    let mezok = this.descriptor;
  
    mezok = mezok.filter(mezo => mezo[section] != (filter ? null : false));
    
    target.mezok = mezok.map((mezo) => ({...mezo, ...mezo[section], form: target, state: {}}));
    target.state = this.state.bind(this,target);
    
    return target;
  }
}